import { Server } from 'lucide-react';
import { useOpsInstances, useOpsInstancesSummary } from '@/api/operations-resources';
import { OperationsResourceInventoryPage } from './operations-resource-inventory-page';
import { opsInstanceColumns, OPS_INSTANCE_TOGGLEABLE_COLUMN_IDS } from './ops-instance-columns';
import { opsInstanceFilterFields } from './ops-resource-filter-fields';

/**
 * Cross-org compute instance inventory for the Tech console — every customer's
 * instances from the local registry (DB-only), with dashboard-style summary,
 * filter by customer/provider/status, and drill to the owning org.
 */
export default function OperationsInstancesPage() {
  return (
    <OperationsResourceInventoryPage
      title="Instances"
      description="Cross-org compute instances — every customer's VMs from the registry."
      searchPlaceholder="Search by name or UID…"
      kindLabel="instances"
      emptyIcon={<Server size={24} />}
      emptyTitle="No instances found"
      columns={opsInstanceColumns}
      toggleableColumnIds={OPS_INSTANCE_TOGGLEABLE_COLUMN_IDS}
      filterFields={opsInstanceFilterFields}
      useList={useOpsInstances}
      useSummary={useOpsInstancesSummary}
    />
  );
}
